import { render, staticRenderFns } from "./Customer_claim.vue?vue&type=template&id=beb87728&"
import script from "./Customer_claim.vue?vue&type=script&lang=js&"
export * from "./Customer_claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports